import { render, staticRenderFns } from "./container.vue?vue&type=template&id=fb546ef2&"
import script from "./container.js?vue&type=script&lang=js&"
export * from "./container.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "container.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VIcon,
  VNavigationDrawer,
})
